import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Live Demo Modal"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn btn-primary py-2 px-4 text-white fw-semibold",
                "data-bs-toggle": "modal",
                "data-bs-target": "#exampleModal"
              }, " Launch demo modal "),
              _createElementVNode("div", {
                class: "modal fade",
                id: "exampleModal",
                tabindex: "-1",
                "aria-labelledby": "exampleModalLabel",
                "aria-hidden": "true"
              }, [
                _createElementVNode("div", { class: "modal-dialog" }, [
                  _createElementVNode("div", { class: "modal-content" }, [
                    _createElementVNode("div", { class: "modal-header" }, [
                      _createElementVNode("h1", {
                        class: "modal-title fs-5",
                        id: "exampleModalLabel"
                      }, " Modal title "),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn-close",
                        "data-bs-dismiss": "modal",
                        "aria-label": "Close"
                      })
                    ]),
                    _createElementVNode("div", { class: "modal-body" }, "Hello Modal"),
                    _createElementVNode("div", { class: "modal-footer" }, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-danger text-white",
                        "data-bs-dismiss": "modal"
                      }, " Close "),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary text-white"
                      }, " Save changes ")
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode"
                }, "\n<!-- Button trigger modal -->\n<button type=\"button\" class=\"btn btn btn-primary py-2 px-4 text-white fw-semibold\" data-bs-toggle=\"modal\" data-bs-target=\"#exampleModal\">\nLaunch demo modal\n</button>\n\n<!-- Modal -->\n<div class=\"modal fade\" id=\"exampleModal\" tabindex=\"-1\" aria-labelledby=\"exampleModalLabel\" aria-hidden=\"true\">\n<div class=\"modal-dialog\">\n<div class=\"modal-content\">\n<div class=\"modal-header\">\n<h1 class=\"modal-title fs-5\" id=\"exampleModalLabel\">Modal title</h1>\n<button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\"></button>\n</div>\n<div class=\"modal-body\">\nHello Modal\n</div>\n<div class=\"modal-footer\">\n<button type=\"button\" class=\"btn btn-danger text-white\" data-bs-dismiss=\"modal\">Close</button>\n<button type=\"button\" class=\"btn btn-primary text-white\">Save changes</button>\n</div>\n</div>\n</div>\n</div>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Static Backdrop Modal"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab2",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview2-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview2-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview2-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code2-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code2-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code2-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent2"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview2-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview2-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary text-white py-2 px-4 fw-semibold",
                "data-bs-toggle": "modal",
                "data-bs-target": "#staticBackdrop"
              }, " Launch static backdrop modal "),
              _createElementVNode("div", {
                class: "modal fade",
                id: "staticBackdrop",
                "data-bs-backdrop": "static",
                "data-bs-keyboard": "false",
                tabindex: "-1",
                "aria-labelledby": "staticBackdropLabel",
                "aria-hidden": "true"
              }, [
                _createElementVNode("div", { class: "modal-dialog" }, [
                  _createElementVNode("div", { class: "modal-content" }, [
                    _createElementVNode("div", { class: "modal-header" }, [
                      _createElementVNode("h1", {
                        class: "modal-title fs-5",
                        id: "staticBackdropLabel"
                      }, " Modal title "),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn-close",
                        "data-bs-dismiss": "modal",
                        "aria-label": "Close"
                      })
                    ]),
                    _createElementVNode("div", { class: "modal-body" }, "Hello Modal"),
                    _createElementVNode("div", { class: "modal-footer" }, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-danger text-white",
                        "data-bs-dismiss": "modal"
                      }, " Close "),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary text-white"
                      }, " Understood ")
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code2-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code2-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode2"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode2"
                }, "\n<!-- Button trigger modal -->\n<button type=\"button\" class=\"btn btn-primary text-white py-2 px-4 fw-semibold\" data-bs-toggle=\"modal\" data-bs-target=\"#staticBackdrop\">\nLaunch static backdrop modal\n</button>\n\n<!-- Modal -->\n<div class=\"modal fade\" id=\"staticBackdrop\" data-bs-backdrop=\"static\" data-bs-keyboard=\"false\" tabindex=\"-1\" aria-labelledby=\"staticBackdropLabel\" aria-hidden=\"true\">\n<div class=\"modal-dialog\">\n<div class=\"modal-content\">\n<div class=\"modal-header\">\n<h1 class=\"modal-title fs-5\" id=\"staticBackdropLabel\">Modal title</h1>\n<button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\"></button>\n</div>\n<div class=\"modal-body\">\nHello Modal\n</div>\n<div class=\"modal-footer\">\n<button type=\"button\" class=\"btn btn-danger text-white\" data-bs-dismiss=\"modal\">Close</button>\n<button type=\"button\" class=\"btn btn-primary text-white\">Understood</button>\n</div>\n</div>\n</div>\n</div>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Scrolling long content modal"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab3",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview3-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview3-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview3-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code3-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code3-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code3-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent3"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview3-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview3-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary text-white py-2 px-4 fw-semibold",
                "data-bs-toggle": "modal",
                "data-bs-target": "#staticBackdrop3"
              }, " Scrolling modal "),
              _createElementVNode("div", {
                class: "modal fade",
                id: "staticBackdrop3",
                "data-bs-backdrop": "static",
                "data-bs-keyboard": "false",
                tabindex: "-1",
                "aria-labelledby": "staticBackdrop3Label",
                "aria-hidden": "true"
              }, [
                _createElementVNode("div", { class: "modal-dialog modal-dialog-scrollable" }, [
                  _createElementVNode("div", { class: "modal-content" }, [
                    _createElementVNode("div", { class: "modal-header" }, [
                      _createElementVNode("h1", {
                        class: "modal-title fs-5",
                        id: "staticBackdrop3Label"
                      }, " Modal Scrolling "),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn-close",
                        "data-bs-dismiss": "modal",
                        "aria-label": "Close"
                      })
                    ]),
                    _createElementVNode("div", { class: "modal-body" }, [
                      _createTextVNode(" Hello Modal Scrolling "),
                      _createElementVNode("p", null, " Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut consequatur sit sed cumque iusto reiciendis expedita magni, ullam deleniti earum soluta maiores id obcaecati deserunt quas minus illo necessitatibus. Dicta! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Ipsum, praesentium perspiciatis sapiente blanditiis itaque incidunt explicabo, quo modi veniam esse ratione, magnam maiores id facilis architecto cum iusto corporis eaque. Lorem ipsum dolor sit amet consectetur adipisicing elit. Cum autem delectus quo omnis, beatae quas nostrum perferendis illo! Sunt fugit rem doloremque eum amet velit porro, dolore et laudantium debitis? Lorem ipsum dolor, sit amet consectetur adipisicing elit. Exercitationem autem asperiores voluptates praesentium reiciendis. Ea nemo fuga nihil consectetur ipsum facere optio quibusdam, officia blanditiis? Delectus laudantium reiciendis fuga corporis? "),
                      _createElementVNode("p", null, " Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut consequatur sit sed cumque iusto reiciendis expedita magni, ullam deleniti earum soluta maiores id obcaecati deserunt quas minus illo necessitatibus. Dicta! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Ipsum, praesentium perspiciatis sapiente blanditiis itaque incidunt explicabo, quo modi veniam esse ratione, magnam maiores id facilis architecto cum iusto corporis eaque. Lorem ipsum dolor sit amet consectetur adipisicing elit. Cum autem delectus quo omnis, beatae quas nostrum perferendis illo! Sunt fugit rem doloremque eum amet velit porro, dolore et laudantium debitis? Lorem ipsum dolor, sit amet consectetur adipisicing elit. Exercitationem autem asperiores voluptates praesentium reiciendis. Ea nemo fuga nihil consectetur ipsum facere optio quibusdam, officia blanditiis? Delectus laudantium reiciendis fuga corporis? "),
                      _createElementVNode("p", null, " Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut consequatur sit sed cumque iusto reiciendis expedita magni, ullam deleniti earum soluta maiores id obcaecati deserunt quas minus illo necessitatibus. Dicta! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Ipsum, praesentium perspiciatis sapiente blanditiis itaque incidunt explicabo, quo modi veniam esse ratione, magnam maiores id facilis architecto cum iusto corporis eaque. Lorem ipsum dolor sit amet consectetur adipisicing elit. Cum autem delectus quo omnis, beatae quas nostrum perferendis illo! Sunt fugit rem doloremque eum amet velit porro, dolore et laudantium debitis? Lorem ipsum dolor, sit amet consectetur adipisicing elit. Exercitationem autem asperiores voluptates praesentium reiciendis. Ea nemo fuga nihil consectetur ipsum facere optio quibusdam, officia blanditiis? Delectus laudantium reiciendis fuga corporis? "),
                      _createElementVNode("p", null, " Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut consequatur sit sed cumque iusto reiciendis expedita magni, ullam deleniti earum soluta maiores id obcaecati deserunt quas minus illo necessitatibus. Dicta! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Ipsum, praesentium perspiciatis sapiente blanditiis itaque incidunt explicabo, quo modi veniam esse ratione, magnam maiores id facilis architecto cum iusto corporis eaque. Lorem ipsum dolor sit amet consectetur adipisicing elit. Cum autem delectus quo omnis, beatae quas nostrum perferendis illo! Sunt fugit rem doloremque eum amet velit porro, dolore et laudantium debitis? Lorem ipsum dolor, sit amet consectetur adipisicing elit. Exercitationem autem asperiores voluptates praesentium reiciendis. Ea nemo fuga nihil consectetur ipsum facere optio quibusdam, officia blanditiis? Delectus laudantium reiciendis fuga corporis? "),
                      _createElementVNode("p", null, " Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut consequatur sit sed cumque iusto reiciendis expedita magni, ullam deleniti earum soluta maiores id obcaecati deserunt quas minus illo necessitatibus. Dicta! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Ipsum, praesentium perspiciatis sapiente blanditiis itaque incidunt explicabo, quo modi veniam esse ratione, magnam maiores id facilis architecto cum iusto corporis eaque. Lorem ipsum dolor sit amet consectetur adipisicing elit. Cum autem delectus quo omnis, beatae quas nostrum perferendis illo! Sunt fugit rem doloremque eum amet velit porro, dolore et laudantium debitis? Lorem ipsum dolor, sit amet consectetur adipisicing elit. Exercitationem autem asperiores voluptates praesentium reiciendis. Ea nemo fuga nihil consectetur ipsum facere optio quibusdam, officia blanditiis? Delectus laudantium reiciendis fuga corporis? "),
                      _createElementVNode("p", null, " Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut consequatur sit sed cumque iusto reiciendis expedita magni, ullam deleniti earum soluta maiores id obcaecati deserunt quas minus illo necessitatibus. Dicta! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Ipsum, praesentium perspiciatis sapiente blanditiis itaque incidunt explicabo, quo modi veniam esse ratione, magnam maiores id facilis architecto cum iusto corporis eaque. Lorem ipsum dolor sit amet consectetur adipisicing elit. Cum autem delectus quo omnis, beatae quas nostrum perferendis illo! Sunt fugit rem doloremque eum amet velit porro, dolore et laudantium debitis? Lorem ipsum dolor, sit amet consectetur adipisicing elit. Exercitationem autem asperiores voluptates praesentium reiciendis. Ea nemo fuga nihil consectetur ipsum facere optio quibusdam, officia blanditiis? Delectus laudantium reiciendis fuga corporis? "),
                      _createElementVNode("p", null, " Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut consequatur sit sed cumque iusto reiciendis expedita magni, ullam deleniti earum soluta maiores id obcaecati deserunt quas minus illo necessitatibus. Dicta! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Ipsum, praesentium perspiciatis sapiente blanditiis itaque incidunt explicabo, quo modi veniam esse ratione, magnam maiores id facilis architecto cum iusto corporis eaque. Lorem ipsum dolor sit amet consectetur adipisicing elit. Cum autem delectus quo omnis, beatae quas nostrum perferendis illo! Sunt fugit rem doloremque eum amet velit porro, dolore et laudantium debitis? Lorem ipsum dolor, sit amet consectetur adipisicing elit. Exercitationem autem asperiores voluptates praesentium reiciendis. Ea nemo fuga nihil consectetur ipsum facere optio quibusdam, officia blanditiis? Delectus laudantium reiciendis fuga corporis? "),
                      _createElementVNode("p", null, " Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut consequatur sit sed cumque iusto reiciendis expedita magni, ullam deleniti earum soluta maiores id obcaecati deserunt quas minus illo necessitatibus. Dicta! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Ipsum, praesentium perspiciatis sapiente blanditiis itaque incidunt explicabo, quo modi veniam esse ratione, magnam maiores id facilis architecto cum iusto corporis eaque. Lorem ipsum dolor sit amet consectetur adipisicing elit. Cum autem delectus quo omnis, beatae quas nostrum perferendis illo! Sunt fugit rem doloremque eum amet velit porro, dolore et laudantium debitis? Lorem ipsum dolor, sit amet consectetur adipisicing elit. Exercitationem autem asperiores voluptates praesentium reiciendis. Ea nemo fuga nihil consectetur ipsum facere optio quibusdam, officia blanditiis? Delectus laudantium reiciendis fuga corporis? "),
                      _createElementVNode("p", null, " Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut consequatur sit sed cumque iusto reiciendis expedita magni, ullam deleniti earum soluta maiores id obcaecati deserunt quas minus illo necessitatibus. Dicta! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Ipsum, praesentium perspiciatis sapiente blanditiis itaque incidunt explicabo, quo modi veniam esse ratione, magnam maiores id facilis architecto cum iusto corporis eaque. Lorem ipsum dolor sit amet consectetur adipisicing elit. Cum autem delectus quo omnis, beatae quas nostrum perferendis illo! Sunt fugit rem doloremque eum amet velit porro, dolore et laudantium debitis? Lorem ipsum dolor, sit amet consectetur adipisicing elit. Exercitationem autem asperiores voluptates praesentium reiciendis. Ea nemo fuga nihil consectetur ipsum facere optio quibusdam, officia blanditiis? Delectus laudantium reiciendis fuga corporis? "),
                      _createElementVNode("p", null, " Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut consequatur sit sed cumque iusto reiciendis expedita magni, ullam deleniti earum soluta maiores id obcaecati deserunt quas minus illo necessitatibus. Dicta! Lorem, ipsum dolor sit amet consectetur adipisicing elit. Ipsum, praesentium perspiciatis sapiente blanditiis itaque incidunt explicabo, quo modi veniam esse ratione, magnam maiores id facilis architecto cum iusto corporis eaque. Lorem ipsum dolor sit amet consectetur adipisicing elit. Cum autem delectus quo omnis, beatae quas nostrum perferendis illo! Sunt fugit rem doloremque eum amet velit porro, dolore et laudantium debitis? Lorem ipsum dolor, sit amet consectetur adipisicing elit. Exercitationem autem asperiores voluptates praesentium reiciendis. Ea nemo fuga nihil consectetur ipsum facere optio quibusdam, officia blanditiis? Delectus laudantium reiciendis fuga corporis? ")
                    ]),
                    _createElementVNode("div", { class: "modal-footer" }, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-danger text-white",
                        "data-bs-dismiss": "modal"
                      }, " Close "),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary text-white"
                      }, " Understood ")
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code3-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code3-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode3"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode3"
                }, "\n<!-- Button trigger modal -->\n<button type=\"button\" class=\"btn btn-primary text-white py-2 px-4 fw-semibold\" data-bs-toggle=\"modal\" data-bs-target=\"#staticBackdrop3\">\nLaunch static backdrop modal\n</button>\n\n<!-- Modal -->\n<div class=\"modal fade\" id=\"staticBackdrop3\" data-bs-backdrop=\"static\" data-bs-keyboard=\"false\" tabindex=\"-1\" aria-labelledby=\"staticBackdrop3Label\" aria-hidden=\"true\">\n<div class=\"modal-dialog modal-dialog-scrollable\">\n<div class=\"modal-content\">\n<div class=\"modal-header\">\n<h1 class=\"modal-title fs-5\" id=\"staticBackdrop3Label\">Modal title</h1>\n<button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\"></button>\n</div>\n<div class=\"modal-body\">\nHello Modal\n</div>\n<div class=\"modal-footer\">\n<button type=\"button\" class=\"btn btn-danger text-white\" data-bs-dismiss=\"modal\">Close</button>\n<button type=\"button\" class=\"btn btn-primary text-white\">Understood</button>\n</div>\n</div>\n</div>\n</div>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Vertically centered Modal"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab4",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview4-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview4-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview4-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code4-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code4-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code4-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent4"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview4-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview4-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn btn-primary py-2 px-4 text-white fw-semibold",
                "data-bs-toggle": "modal",
                "data-bs-target": "#exampleModal4"
              }, " Center demo modal "),
              _createElementVNode("div", {
                class: "modal fade",
                id: "exampleModal4",
                tabindex: "-1",
                "aria-labelledby": "exampleModalLabel",
                "aria-hidden": "true"
              }, [
                _createElementVNode("div", { class: "modal-dialog modal-dialog-centered" }, [
                  _createElementVNode("div", { class: "modal-content" }, [
                    _createElementVNode("div", { class: "modal-header" }, [
                      _createElementVNode("h1", {
                        class: "modal-title fs-5",
                        id: "exampleModalLabel"
                      }, " Modal title "),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn-close",
                        "data-bs-dismiss": "modal",
                        "aria-label": "Close"
                      })
                    ]),
                    _createElementVNode("div", { class: "modal-body" }, "Hello Modal Center"),
                    _createElementVNode("div", { class: "modal-footer" }, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-danger text-white",
                        "data-bs-dismiss": "modal"
                      }, " Close "),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary text-white"
                      }, " Save changes ")
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code4-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code4-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode4"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode4"
                }, "\n<button type=\"button\" class=\"btn btn btn-primary py-2 px-4 text-white fw-semibold\" data-bs-toggle=\"modal\" data-bs-target=\"#exampleModal4\">\nCenter demo modal\n</button>\n\n<!-- Modal -->\n<div class=\"modal fade\" id=\"exampleModal4\" tabindex=\"-1\" aria-labelledby=\"exampleModalLabel\" aria-hidden=\"true\">\n<div class=\"modal-dialog modal-dialog-centered\">\n<div class=\"modal-content\">\n<div class=\"modal-header\">\n<h1 class=\"modal-title fs-5\" id=\"exampleModalLabel\">Modal title</h1>\n<button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\"></button>\n</div>\n<div class=\"modal-body\">\nHello Modal Center\n</div>\n<div class=\"modal-footer\">\n<button type=\"button\" class=\"btn btn-danger text-white\" data-bs-dismiss=\"modal\">Close</button>\n<button type=\"button\" class=\"btn btn-primary text-white\">Save changes</button>\n</div>\n</div>\n</div>\n</div>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Extra large modal"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab5",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview5-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview5-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview5-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code5-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code5-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code5-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent5"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview5-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview5-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn btn-primary py-2 px-4 text-white fw-semibold",
                "data-bs-toggle": "modal",
                "data-bs-target": "#exampleModalxl"
              }, " Extra large modal "),
              _createElementVNode("div", {
                class: "modal fade",
                id: "exampleModalxl",
                tabindex: "-1",
                "aria-labelledby": "exampleModalLabel",
                "aria-hidden": "true"
              }, [
                _createElementVNode("div", { class: "modal-dialog modal-xl" }, [
                  _createElementVNode("div", { class: "modal-content" }, [
                    _createElementVNode("div", { class: "modal-header" }, [
                      _createElementVNode("h1", {
                        class: "modal-title fs-5",
                        id: "exampleModalLabel"
                      }, " Extra large modal "),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn-close",
                        "data-bs-dismiss": "modal",
                        "aria-label": "Close"
                      })
                    ]),
                    _createElementVNode("div", { class: "modal-body" }, "Hello Modal Center"),
                    _createElementVNode("div", { class: "modal-footer" }, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-danger text-white",
                        "data-bs-dismiss": "modal"
                      }, " Close "),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary text-white"
                      }, " Save changes ")
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code5-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code5-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode5"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode5"
                }, "\n<!-- Button trigger modal -->\n<button type=\"button\" class=\"btn btn btn-primary py-2 px-4 text-white fw-semibold\" data-bs-toggle=\"modal\" data-bs-target=\"#exampleModalxl\">\nCenter demo modal\n</button>\n\n<!-- Modal -->\n<div class=\"modal fade\" id=\"exampleModalxl\" tabindex=\"-1\" aria-labelledby=\"exampleModalLabel\" aria-hidden=\"true\">\n<div class=\"modal-dialog modal-xl\">\n<div class=\"modal-content\">\n<div class=\"modal-header\">\n<h1 class=\"modal-title fs-5\" id=\"exampleModalLabel\">Modal title</h1>\n<button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\"></button>\n</div>\n<div class=\"modal-body\">\nHello Modal Center\n</div>\n<div class=\"modal-footer\">\n<button type=\"button\" class=\"btn btn-danger text-white\" data-bs-dismiss=\"modal\">Close</button>\n<button type=\"button\" class=\"btn btn-primary text-white\">Save changes</button>\n</div>\n</div>\n</div>\n</div>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Large modal"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab6",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview6-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview6-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview6-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code6-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code6-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code6-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent6"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview6-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview6-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn btn-primary py-2 px-4 text-white fw-semibold",
                "data-bs-toggle": "modal",
                "data-bs-target": "#exampleModallg"
              }, " Large modal "),
              _createElementVNode("div", {
                class: "modal fade",
                id: "exampleModallg",
                tabindex: "-1",
                "aria-labelledby": "exampleModalLabel",
                "aria-hidden": "true"
              }, [
                _createElementVNode("div", { class: "modal-dialog modal-lg" }, [
                  _createElementVNode("div", { class: "modal-content" }, [
                    _createElementVNode("div", { class: "modal-header" }, [
                      _createElementVNode("h1", {
                        class: "modal-title fs-5",
                        id: "exampleModalLabel"
                      }, " Large modal "),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn-close",
                        "data-bs-dismiss": "modal",
                        "aria-label": "Close"
                      })
                    ]),
                    _createElementVNode("div", { class: "modal-body" }, "Hello Modal Center"),
                    _createElementVNode("div", { class: "modal-footer" }, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-danger text-white",
                        "data-bs-dismiss": "modal"
                      }, " Close "),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary text-white"
                      }, " Save changes ")
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code6-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code6-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode6"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode6"
                }, "\n<!-- Button trigger modal -->\n<button type=\"button\" class=\"btn btn btn-primary py-2 px-4 text-white fw-semibold\" data-bs-toggle=\"modal\" data-bs-target=\"#exampleModallg\">\nLarge modal\n</button>\n\n<!-- Modal -->\n<div class=\"modal fade\" id=\"exampleModallg\" tabindex=\"-1\" aria-labelledby=\"exampleModalLabel\" aria-hidden=\"true\">\n<div class=\"modal-dialog modal-lg\">\n<div class=\"modal-content\">\n<div class=\"modal-header\">\n<h1 class=\"modal-title fs-5\" id=\"exampleModalLabel\">Large modal</h1>\n<button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\"></button>\n</div>\n<div class=\"modal-body\">\nHello Modal Center\n</div>\n<div class=\"modal-footer\">\n<button type=\"button\" class=\"btn btn-danger text-white\" data-bs-dismiss=\"modal\">Close</button>\n<button type=\"button\" class=\"btn btn-primary text-white\">Save changes</button>\n</div>\n</div>\n</div>\n</div>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Checkboxes and radios List"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab7",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview7-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview7-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview8-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code8-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code8-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code8-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent8"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview8-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview8-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn btn-primary py-2 px-4 text-white fw-semibold",
                "data-bs-toggle": "modal",
                "data-bs-target": "#exampleModalsm"
              }, " Small modal "),
              _createElementVNode("div", {
                class: "modal fade",
                id: "exampleModalsm",
                tabindex: "-1",
                "aria-labelledby": "exampleModalLabel",
                "aria-hidden": "true"
              }, [
                _createElementVNode("div", { class: "modal-dialog modal-sm" }, [
                  _createElementVNode("div", { class: "modal-content" }, [
                    _createElementVNode("div", { class: "modal-header" }, [
                      _createElementVNode("h1", {
                        class: "modal-title fs-5",
                        id: "exampleModalLabel"
                      }, " Small modal "),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn-close",
                        "data-bs-dismiss": "modal",
                        "aria-label": "Close"
                      })
                    ]),
                    _createElementVNode("div", { class: "modal-body" }, "Hello Modal Center"),
                    _createElementVNode("div", { class: "modal-footer" }, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-danger text-white",
                        "data-bs-dismiss": "modal"
                      }, " Close "),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary text-white"
                      }, " Save changes ")
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code8-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code6-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode8"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode8"
                }, "\n<!-- Button trigger modal -->\n<button type=\"button\" class=\"btn btn btn-primary py-2 px-4 text-white fw-semibold\" data-bs-toggle=\"modal\" data-bs-target=\"#exampleModalsm\">\nSmall modal\n</button>\n\n<!-- Modal -->\n<div class=\"modal fade\" id=\"exampleModalsm\" tabindex=\"-1\" aria-labelledby=\"exampleModalLabel\" aria-hidden=\"true\">\n<div class=\"modal-dialog modal-sm\">\n<div class=\"modal-content\">\n<div class=\"modal-header\">\n<h1 class=\"modal-title fs-5\" id=\"exampleModalLabel\">Small modal</h1>\n<button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\"></button>\n</div>\n<div class=\"modal-body\">\nHello Modal Center\n</div>\n<div class=\"modal-footer\">\n<button type=\"button\" class=\"btn btn-danger text-white\" data-bs-dismiss=\"modal\">Close</button>\n<button type=\"button\" class=\"btn btn-primary text-white\">Save changes</button>\n</div>\n</div>\n</div>\n</div>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1)
  ]))]))
}